/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_R2_Bucket_NameInputs */

const en_admin_settings_fields_r2_bucket_name = /** @type {(inputs: Admin_Settings_Fields_R2_Bucket_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bucket Name`)
};

/**
* | output |
* | --- |
* | "Bucket Name" |
*
* @param {Admin_Settings_Fields_R2_Bucket_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_r2_bucket_name = /** @type {((inputs?: Admin_Settings_Fields_R2_Bucket_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_R2_Bucket_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_r2_bucket_name(inputs)
});
export { admin_settings_fields_r2_bucket_name as "admin.settings.fields.r2_bucket_name" }